import React from 'react'

const AssetsPage = () => {
  return <div>Hi</div>
}

export default AssetsPage
